module.exports = __webpack_public_path__ + "img/sr09_samurai02skin_shop.1733f1b8.png";